"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("lodash");
var React = require("react");
var ReactBootstrap = require("react-bootstrap");
var Fade = ReactBootstrap.Fade;
var NotificationMessageNotifier = (function (_super) {
    tslib_1.__extends(NotificationMessageNotifier, _super);
    function NotificationMessageNotifier(props) {
        var _this = _super.call(this, props) || this;
        _this.messageKey = "notification/lastMessages";
        _this.getMessagesToUpdate = function () {
            if (!_this.state.messages || _this.state.messages.length < 1) {
                return [];
            }
            return JSON.parse(JSON.stringify(_this.state.messages));
        };
        _this.handleDismiss = function (id) {
            var updatedMessages = _this.getMessagesToUpdate();
            var message = updatedMessages.find(function (msg) { return msg.id === id; });
            if (message) {
                message.viewed = true;
            }
            _this.updateLocalStorage(updatedMessages);
            _this.setState({
                messages: updatedMessages
            });
        };
        _this.toggleMessage = function () {
            var updatedMessages = _this.getMessagesToUpdate();
            var someMessagesShown = updatedMessages.some(function (msg) { return !msg.viewed; });
            var toggledViewStatus = someMessagesShown;
            var messagesWithViewStatus = updatedMessages.map(function (msg) { msg.viewed = toggledViewStatus; return msg; });
            _this.updateLocalStorage(messagesWithViewStatus);
            _this.setState({
                messages: messagesWithViewStatus
            });
        };
        _this.state = {
            messages: []
        };
        return _this;
    }
    NotificationMessageNotifier.prototype.componentDidMount = function () {
        var _this = this;
        fetch("api/navigation/notification", { credentials: "same-origin" }).then(function (response) {
            if (response.ok) {
                response.json().then(function (result) {
                    var messages = _this.updateViewedStatusFromLocalStorage(result) || [];
                    _this.setState({
                        messages: messages
                    });
                }).catch(function (err) { return Promise.reject(err); });
            }
            else {
                response.json().then(function (err) { return Promise.reject(err); });
            }
        }).catch(function (err) { return console.error("Unable to retrive notification message: " + err); });
    };
    NotificationMessageNotifier.prototype.render = function () {
        var _this = this;
        if (this.state.messages == null || this.state.messages.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: this.props.className },
            React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                React.createElement("li", null,
                    React.createElement("p", { className: "navbar-text pointer " },
                        React.createElement("span", { className: "glyphicon glyphicon-warning-sign state-color-started", onClick: this.toggleMessage })))),
            React.createElement("div", { className: "clear notification-alert-container" }, _.map(this.state.messages, function (message) {
                return React.createElement(NotificationMessageViewer, { key: message.id, message: message.message, viewed: message.viewed, messageId: message.id, onDismiss: _this.handleDismiss });
            }))));
    };
    NotificationMessageNotifier.prototype.updateViewedStatusFromLocalStorage = function (messages) {
        if (typeof (Storage) !== "undefined") {
            var localStoreMessages_1 = JSON.parse(localStorage.getItem(this.messageKey)) || [];
            var updatedMessages = (messages || []).map(function (msg) {
                var localMessage = localStoreMessages_1.find(function (lmsg) { return lmsg.id === msg.id; });
                if (localMessage != null) {
                    msg.viewed = localMessage.viewed;
                }
                return msg;
            });
            return updatedMessages;
        }
    };
    NotificationMessageNotifier.prototype.updateLocalStorage = function (messages) {
        if (typeof (Storage) !== "undefined") {
            var messageStatuses = (messages || []).map(function (msg) { return ({ id: msg.id, viewed: msg.viewed }); });
            localStorage.setItem(this.messageKey, JSON.stringify(messageStatuses));
        }
    };
    return NotificationMessageNotifier;
}(React.Component));
exports.NotificationMessageNotifier = NotificationMessageNotifier;
var NotificationMessageViewer = (function (_super) {
    tslib_1.__extends(NotificationMessageViewer, _super);
    function NotificationMessageViewer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleDismissClick = function () {
            _this.props.onDismiss(_this.props.messageId);
        };
        return _this;
    }
    NotificationMessageViewer.prototype.render = function () {
        return (React.createElement(Fade, { in: !this.props.viewed, unmountOnExit: true },
            React.createElement("div", { className: "clear" },
                React.createElement("div", { className: "alert alert-warning notification-alert" },
                    React.createElement("span", { className: "close", onClick: this.handleDismissClick }, "\u00D7"),
                    React.createElement("p", null, this.props.message)))));
    };
    return NotificationMessageViewer;
}(React.Component));
exports.NotificationMessageViewer = NotificationMessageViewer;
